import { render, staticRenderFns } from "./ViewFinancialReport.vue?vue&type=template&id=f2388520&scoped=true&"
import script from "./ViewFinancialReport.vue?vue&type=script&lang=js&"
export * from "./ViewFinancialReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2388520",
  null
  
)

export default component.exports